import type {
  ChangeEvent,
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";
import {
  CertificationInputField,
  CertificationSelectField,
  CertificationTextareaField,
} from "@modules/certificaciones/shared/ui";

export function Iso900114001Input({
  label,
  fullWidth = false,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { label: string; fullWidth?: boolean }) {
  return <CertificationInputField label={label} fullWidth={fullWidth} {...props} />;
}

export function Iso900114001Textarea({
  label,
  fullWidth = false,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement> & { label: string; fullWidth?: boolean }) {
  return <CertificationTextareaField label={label} fullWidth={fullWidth} {...props} />;
}

export function Iso900114001Select({
  label,
  fullWidth = false,
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { label: string; fullWidth?: boolean }) {
  return (
    <CertificationSelectField label={label} fullWidth={fullWidth} {...props}>
      {children}
    </CertificationSelectField>
  );
}

export function Iso900114001Checkbox({
  label,
  checked,
  disabled = false,
  onChange,
}: {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label className={`iso9001-checkbox${disabled ? " disabled" : ""}`}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
      />
      <span>{label}</span>
    </label>
  );
}
